import { useEffect, useState } from 'react';

export const useCountries = () => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/external_apis/proxy.php?type=countries`);
        const data = await response.json();
        const formattedCountries = data.map(country => ({
          code: country.cca2,
          name: country.name.common,
          phoneCode: country.idd?.root ? `${country.idd.root.replace('+', '')}${(country.idd.suffixes && country.idd.suffixes[0]) || ''}`   : '',
        }));
        // Tri alphabétique pour affichage propre
        formattedCountries.sort((a, b) => a.name.localeCompare(b.name));
        setCountries(formattedCountries);
      } catch (error) {
        console.error("Erreur lors de la récupération des pays:", error);
      }
    };
    fetchCountries();
  }, []);

  return countries;
};
